module.exports = "<div id=\"dashboard\">\n  <app-program-list></app-program-list>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/dashboard.component.html
// module id = ../../../../../src/app/dashboard/dashboard.component.html
// module chunks = 2